import { useMemo } from 'react';

type UseGetValidityDays = {
  startDate?: string | Date;
  endDate?: string | Date;
};

export const useGetValidityDays = ({
  startDate,
  endDate,
}: UseGetValidityDays) => {
  const validityDays = useMemo(() => {
    if (!startDate || !endDate) return 0;

    const start = new Date(startDate);
    const end = new Date(endDate);

    const timeDiff = end.getTime() - start.getTime();

    const daysDiff = Math.ceil(timeDiff / (1000 * 3600 * 24));

    return daysDiff > 0 ? daysDiff : 0;
  }, [startDate, endDate]);

  return {
    data: {
      validityDays,
    },
  };
};
